/**
 * Minimal, dependency-free className combiner. Filters out falsy values so you
 * can write `cn('base', isActive && 'active', className)`. Kept dependency-free
 * on purpose; if richer Tailwind conflict-resolution is ever needed, swap in
 * clsx + tailwind-merge behind this same signature.
 */
export type ClassValue = string | number | false | null | undefined;

export function cn(...values: ClassValue[]): string {
  return values.filter(Boolean).join(' ');
}
